/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Import_Summary_Nothing_New_DescInputs */

const en_ui_import_summary_nothing_new_desc = /** @type {(inputs: Ui_Import_Summary_Nothing_New_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing new on intervals.icu.`)
};

const de_ui_import_summary_nothing_new_desc = /** @type {(inputs: Ui_Import_Summary_Nothing_New_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nichts Neues auf intervals.icu.`)
};

/**
* | output |
* | --- |
* | "Nothing new on intervals.icu." |
*
* @param {Ui_Import_Summary_Nothing_New_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_import_summary_nothing_new_desc = /** @type {((inputs?: Ui_Import_Summary_Nothing_New_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Import_Summary_Nothing_New_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_import_summary_nothing_new_desc(inputs)
	return de_ui_import_summary_nothing_new_desc(inputs)
});